export const viewportCoordsToSceneCoords = (
  { clientX, clientY }: { clientX: number; clientY: number },
  {
    offsetLeft,
    offsetTop,
    scrollX,
    scrollY,
    zoom,
  }: {
    offsetLeft: number;
    offsetTop: number;
    scrollX: number;
    scrollY: number;
    zoom: number;
  },
) => {
  const x = (clientX - offsetLeft) / zoom - scrollX;
  const y = (clientY - offsetTop) / zoom - scrollY;
  return { x, y };
};
